import script from "./batchLinkCloudDisk.vue?vue&type=script&lang=ts&setup=true"
export * from "./batchLinkCloudDisk.vue?vue&type=script&lang=ts&setup=true"

import "./batchLinkCloudDisk.vue?vue&type=style&index=0&id=fe123396&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe123396"]])

export default __exports__